import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the NumericoPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'barcode',
})
export class BarcodePipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: number, ...args) { // ...args -> quando aceita infinitos argumentos?

        return this.util.barcode(value);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/barcode/barcode.ts